import { Button } from 'components/buttons/Button/Button';
import './styles.scss';
import GradientText from 'components/GradientText';
import { useSelector } from 'react-redux';
import { ROUTES } from 'constants/routes';
import { selectHomepage } from 'store/slices/HomepageSlice';

const TrialResults = () => {
    const {
        discover_information_description,
        discover_information_title,
        discover_nutrition_background,
        discover_nutrition_description,
        discover_nutrition_title,
        discover_trial_description,
        discover_trial_image,
        discover_trial_title,
        discover_title,
    } = useSelector(selectHomepage);

    return (
        <>
            <section className="container">
                <div className="trial-results">
                    <GradientText size="middle" textColor="white">
                        <span dangerouslySetInnerHTML={{ __html: discover_title }} />
                    </GradientText>
                    <div className="asdasd">
                        <div className="asdasd-1">
                            <img src={discover_trial_image} alt="charts" />
                            <div className="asdasd-1-content">
                                <div className="asdasd-title">{discover_trial_title}</div>
                                <p className="asdasd-text">{discover_trial_description}</p>
                                <Button href={ROUTES.trialResults} type="learn-more-arrow" />
                            </div>
                        </div>
                        <div
                            className="asdasd-2"
                            style={{
                                backgroundImage: `linear-gradient(180deg, rgba(9, 20, 21, 0.5) 0%, rgba(9, 20, 21, 0) 49.75%), url(${discover_nutrition_background})`,
                            }}
                        >
                            <div className="asdasd-title">{discover_nutrition_title}</div>
                            <p className="asdasd-text">{discover_nutrition_description}</p>
                            <Button href={ROUTES.cropNutritionPrograms} type="learn-more-arrow" />
                        </div>
                        <div className="asdasd-3">
                            <div className="asdasd-title">{discover_information_title}</div>
                            <p className="asdasd-text">{discover_information_description}</p>
                            <Button href={ROUTES.informationMaterials} type="learn-more-arrow" />
                        </div>
                    </div>
                    {/* <div className="trial-results__inner-container">
                        <div className="trial-results__content">
                            <div className="trial-results__up">
                                <img src={discover_trial_image} alt="charts" />
                            </div>
                            <div className="trial-results__down">
                                <h4>{discover_trial_title}</h4>
                                <p className="body1">{discover_trial_description}</p>
                                <Button href={ROUTES.trialResults} type="learn-more-arrow" />
                            </div>
                        </div>
                        <div
                            className="crop-nutrition"
                            style={{ backgroundImage: `url(${discover_nutrition_background})` }}
                        >
                            <div>
                                <h4>{discover_nutrition_title}</h4>
                                <p className="body1">{discover_nutrition_description}</p>
                                <Button href={ROUTES.cropNutritionPrograms} type="learn-more-arrow" />
                            </div>
                        </div>
                        <div className="information-materials">
                            <h4>{discover_information_title}</h4>
                            <p className="body1">{discover_information_description}</p>
                            <Button href={ROUTES.informationMaterials} type="learn-more-arrow" />
                        </div>
                    </div> */}
                </div>
            </section>
        </>
    );
};

export default TrialResults;
